var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBornCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.92 22.744V9.04898H2.49V22.744H19.92ZM16.185 0.333984H18.675V2.82398H19.92C20.5804 2.82398 21.2137 3.08632 21.6807 3.55329C22.1477 4.02025 22.41 4.6536 22.41 5.31398V22.744C22.41 24.1259 21.302 25.234 19.92 25.234H2.49C1.82961 25.234 1.19627 24.9716 0.729304 24.5047C0.262338 24.0377 0 23.4044 0 22.744V5.31398C0 3.94448 1.1205 2.82398 2.49 2.82398H3.735V0.333984H6.225V2.82398H16.185V0.333984ZM11.205 20.4656L10.4829 19.8058C7.9182 17.4776 6.225 15.9463 6.225 14.0663C6.225 12.535 7.43265 11.3273 8.964 11.3273C9.8355 11.3273 10.6572 11.7257 11.205 12.3607C11.7528 11.7257 12.5745 11.3273 13.446 11.3273C14.9774 11.3273 16.185 12.535 16.185 14.0663C16.185 15.9463 14.4918 17.4776 11.9271 19.8058L11.205 20.4656Z",
    fill: "#CB2129"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBornCalendar);
export default __webpack_public_path__ + "static/media/born-calendar.04cb0410c5aa0b29d391aa3a1a78af7f.svg";
export { ForwardRef as ReactComponent };